import styled, { css } from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { Image } from '../../Image';
import { ThumbnailButtonProps } from './types';

const IMAGE_WIDTH = 96;
const IMAGE_HEIGHT = 72;

export const ThumbnailButtonElementWrapper = styled.li`
    &:not(:first-child) {
        margin-left: ${getSpacingToken('50')}px;
    }
`;

export const ThumbnailButtonElement = styled.button<ThumbnailButtonProps>`
    background: none;
    display: inline-block;
    cursor: pointer;
    min-width: ${IMAGE_WIDTH}px;
    width: ${IMAGE_WIDTH}px;
    height: ${IMAGE_HEIGHT}px;
    border-radius: 4px;
    overflow: hidden;
    user-select: none;
    padding: 0;
    border: 2px solid transparent;
    opacity: 0.5;

    ${(props) =>
        props.selected &&
        css`
            border-color: ${getToken('borderInteractiveFocus')};
            opacity: 1;
            outline: none;
        `}
`;

export const ImageListContainerElement = styled.div`
    display: flex;
    justify-content: center;
    overflow-x: hidden;
    position: relative;
    width: 100%;
`;

export const ListImageElement = styled(Image)`
    object-fit: cover;
    user-select: none;
    width: 100%;
    height: 100%;
    vertical-align: middle;
`;
